module.exports = __webpack_public_path__ + "img/Weaving.eef94b5c.png";